import gql from "graphql-tag";

// TODO make th
export const ListEvents = gql`
  query ListEvents (
    $filter: TableEventFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value: id 
        text: title
        location
        type
        competitions {
          id: competitionId
          code
          date
          beginTime
          endTime
          organizer
    	  competitionRulesURL 
          teamMemberLimit
          participantLimit
      	  robotRequired
      	  published
          difficulty
          i18n_title
          i18n_description
        }
      }
    }
  }
`;


export const Create = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      competitionId
      userId
      eventId
      name
      robotName
      hasAcceptedCompetitionRules
      mentor
      members
    }
  }
`;


export const Mentor = gql`
  query Mentor($userId: String!) {
    getMentorAttributes(userId: $userId) {
      items {
        Name
        Value
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/CsvImport/graphql.js